module.exports = __webpack_public_path__ + "static/media/NHS_logo2.63f8794e.svg";